import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from "rxjs";
import { PosCampanhaService } from "../../service/posCampanha/pos-campanha.service";
import { Page } from "../../model/Paginacao/Page";
import { ServidorRecad } from "../../model/servidorRecad";
import * as moment from "moment";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from "@angular/material/tabs";
import { AbasDisponiveis } from 'app/model/abasDisponiveis.dto';
import { Aba8PosrecadComponent } from 'app/components/pos-recadastramento/aba8-posrecad/aba8-posrecad.component';
interface Atributo {
  label: string;
}
@Component({
  selector: 'app-pos-campanha-recadastramento',
  templateUrl: './pos-campanha-recadastramento.component.html',
  styleUrls: ['./pos-campanha-recadastramento.component.sass']
})

export class PosCampanhaRecadastramentoComponent implements OnInit, OnDestroy {
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('aba8Component') aba8Component: Aba8PosrecadComponent;
  dataSource: MatTableDataSource<ServidorRecad> = new MatTableDataSource<ServidorRecad>([]);
  displayedColumns: string[] = ['nome', /* Add more columns here */];
  totalElements: number = 0;
  pageSize: number = 10;
  mostraResultado: boolean = false;
  mostraTabs: boolean = false;
  currentTab = 0;
  private filtros: any;
  dialog: any;
  servidor: ServidorRecad;
  flExibirTab1: boolean = true;
  flSalvo: boolean;
  atributos: Atributo[] = [];
  pagina: number = 0;
  itens: number = 10;

  btnDesativadoContatos: boolean = false;
  btnDesativadoDadosPessoais: boolean = false;
  btnDesativadoDocumentos: boolean = false;
  btnDesativadoEnderecos: boolean = false;
  btnDesativadoTrabEstrangeiro: boolean = false;
  btnDesativadoPcd: boolean = false;
  btnDesativadoParentesco: boolean = false;
  btnDesativadoAuxTransporte: boolean = false;
  btnDesativadoVinculos: boolean = false;
  btnDesativadoConselhos: boolean = false;

  constructor(private toastrService: ToastrService, private posCampanhaService: PosCampanhaService) { }

  ngOnDestroy(): void {
    this.botoesDesabilitadosContatos(false);
    this.botoesDesabilitadosDadosPessoais(false);
    this.botoesDesabilitadosDocumentos(false);
    this.botoesDesabilitadosEnderecos(false);
    this.botoesDesabilitadosTrabEstrangeiro(false);
    this.botoesDesabilitadosPcd(false);
    this.botoesDesabilitadosParentesco(false);
    this.botoesDesabilitadosAuxTransporte(false);
    this.botoesDesabilitadosVinculos(false);
    this.botoesDesabilitadosConselhos(false);
  }

  ngOnInit(): void {
    this.botoesDesabilitadosContatos(false);
    this.botoesDesabilitadosDadosPessoais(false);
    this.botoesDesabilitadosDocumentos(false);
    this.botoesDesabilitadosEnderecos(false);
    this.botoesDesabilitadosTrabEstrangeiro(false);
    this.botoesDesabilitadosPcd(false);
    this.botoesDesabilitadosParentesco(false);
    this.botoesDesabilitadosAuxTransporte(false);
    this.botoesDesabilitadosVinculos(false);
    this.botoesDesabilitadosConselhos(false);

  }

  carregarListaServidores(filtros){
    this.filtros = filtros;
    this.filtros == null ? (this.mostraResultado = false, this.mostraTabs = false) : this.filtrarRecadastramentos();
  }
  ordenarAtributos() {
    const ordemDesejada = ['dadosPessoais', 'documentosPessoais', 'endereco','deficiencia', 'dependentes', 'contatos', 'parentesco', 'auxSaude', 'auxTransporte', 'outroVinculo', 'conselho'];
    return this.atributos.sort((a, b) => {
      const indexA = ordemDesejada.indexOf(a.label);
      const indexB = ordemDesejada.indexOf(b.label);
      return indexA - indexB;
    });
  }

  filtrarRecadastramentos(pagina: number = 0, itens: number = 10){
    this.mostraTabs = false
    this.filtros.itens = itens;
    this.filtros.pagina = pagina;
    this.getRecadastramentos(this.filtros).subscribe( resp => {
      this.dataSource.data = resp.content;
      this.totalElements = resp.totalElements;
      this.mostraResultado = true
    })
  }

  private verificarConcessaoRecadastramento(idRecadad){
    this.verificarAbasDisponiveis(idRecadad).subscribe( resp => {
    this.atributos = Object.entries(resp).map(([label, valor]) => ({ label, valor }));
    })
    this.mostraTabs = true;
  }

  private verificarAbasDisponiveis(idRecadad): Observable<AbasDisponiveis> {
    return this.posCampanhaService.verificarConcessaoRecadastramento(idRecadad);
  }

  private getRecadastramentos(filtro): Observable<Page<ServidorRecad>> {
    return this.posCampanhaService.getRecadastramentos(filtro);
  }

  onPageChange(event: any): void {
    this.pagina = event.pageIndex;
    this.itens = event.pageSize;

    this.filtrarRecadastramentos( this.pagina, this.itens);
  }

  onCellClick(servidorId: ServidorRecad): void {
    this.mostraTabs = false;
    if(this.flSalvo){
      this.filtrarRecadastramentos(this.pagina, this.itens);
    }

    this.servidor = servidorId;
    this.verificarConcessaoRecadastramento(servidorId.id);

    this.btnDesativadoContatos = false;
    this.btnDesativadoDadosPessoais = false;
    this.btnDesativadoDocumentos = false;
    this.btnDesativadoEnderecos = false;
    this.btnDesativadoTrabEstrangeiro = false;
    this.btnDesativadoPcd = false;
    this.btnDesativadoParentesco = false;
    this.btnDesativadoAuxTransporte = false;
    this.btnDesativadoConselhos = false;
    this.btnDesativadoVinculos = false;

  }

  myTabSelectedTabChange(changeEvent: MatTabChangeEvent) {
    this.currentTab = changeEvent.index;
  }


  exibirTab(event) {
    this.flExibirTab1 = event;
  }

  isSave(event) {
    this.flSalvo = event;
  }

  botoesDesabilitadosContatos(event: boolean) {
    this.btnDesativadoContatos = event;
  }

  botoesDesabilitadosDadosPessoais(event: boolean) {
    this.btnDesativadoDadosPessoais = event;
  }

  botoesDesabilitadosDocumentos(event: boolean) {
    this.btnDesativadoDocumentos = event;
  }

  botoesDesabilitadosEnderecos(event: boolean) {
    this.btnDesativadoEnderecos = event;
  }

  botoesDesabilitadosTrabEstrangeiro(event: boolean) {
    this.btnDesativadoTrabEstrangeiro = event;
  }

  botoesDesabilitadosPcd(event: boolean) {
    this.btnDesativadoPcd = event;
  }

  botoesDesabilitadosParentesco(event: boolean) {
    this.btnDesativadoParentesco = event;
  }

  botoesDesabilitadosAuxTransporte(event: boolean) {
    this.btnDesativadoAuxTransporte = event;
  }

  botoesDesabilitadosVinculos(event: boolean) {
    this.btnDesativadoVinculos = event;
  }

  botoesDesabilitadosConselhos(event: boolean) {
    this.btnDesativadoConselhos = event;
  }

}

